import { ChannelsTable } from './ChannelsTable';
import { Cross } from './Cross';
import { Disclaimer } from './Disclaimer';
import { Full } from './Full';
import { Gates } from './Gates';
import { LinesTable } from './LinesTable';
import { PHS } from './PHS';
import { Tags } from './Tags';
import { Variables } from './Variables';
import { VariablesAdv } from './VariablesAdv';
import { Definition } from './Definition';
import { PentaFirst } from './PentaFirst';
import { PentaCompare } from '../Penta/PentaCompare';
import { PentaTags } from '../Penta/PentaTags';
import { PentaPHS } from '../Penta/PentaPHS';
import { PentaChannels } from './PentaChannels';
import { PentaCrosses } from '../Penta/PentaCrosses';
import { PentaAstro } from '../Penta/PentaAstro';
import { PentaJyotish } from '../Penta/PentaJyotish';



export const narrativesComponents = {
  default: <Full //No bodygraph
    numbers={false}
    planets={false}
    advanced={false}
    hoverable={true}
    noSettings={false}
    pentaSettings={{
      noSettings: true,
      hoverable: true,
      noSearch: true,
      noHints: true,
      hints: false,
    }}
  />,
  calculate: <Full
    noBodyView={true}
    hints={false}
    numbers={false}
    planets={false}
    advanced={false}
    hoverable={true}
    noSettings={false}
    pentaSettings={{
      noSettings: true,
      hoverable: true,
      noSearch: true,
      noHints: true,
      hints: true,
    }}
  />,
  full: <Full
    noBodyView={false}
    hints={false}
    noHints={true}
    numbers={true}
    planets={true}
    advanced={true}
    hoverable={true}
    noSettings={false}
    pentaSettings={{
      noSettings: true,
      hoverable: true,
      noSearch: true,
      noHints: true,
      hints: true,
    }}
  />,
  variables: <Variables />,
  variables_adv: <VariablesAdv />,
  phs: <PHS />,
  linesAdv: <LinesTable />,
  channelsAdv: <ChannelsTable />,
  gates: <Gates />,
  gatesAdv: <Gates advanced={true} />,
  cross: <Cross />,
  disclaimer: <Disclaimer />,
  tags: <Tags />,
  definition: <Definition />
}

export const pentaNarrativeComponents = {
  composite: <PentaFirst aura={true} />,
  compare: <PentaCompare />,
  penta_tags: <PentaTags />,
  penta_phs: <PentaPHS advanced={true} videos={false} />,
  penta_em: <PentaChannels view={['em']} />,
  penta_same: <PentaChannels view={['same']} />,
  penta_dom: <PentaChannels view={['dom']} />,
  penta_individual_channels: <PentaChannels view={['individual']} />,
  penta_cross: <PentaCrosses />,
  penta_astrology: <PentaAstro />,
  penta_jyotish: <PentaJyotish />,
}

export const buildPentaNarratives = (narrativesJson = {}, pagesJson = {}) => {
  const pages = {};
  Object.values(pagesJson).forEach((page) => {
    if (page && typeof page === 'object' && page.id) pages[page.id] = page;
  });

  const result = {};
  Object.values(narrativesJson).forEach((narrative) => {
    if (!narrative || typeof narrative !== 'object' || !narrative.id) return;
    result[narrative.id] = {
      ...narrative,
      pages: (narrative.pages || []).map((pageId) => pages[pageId]).filter(Boolean),
    };
  });
  return result;
}





export const getNarrative = (id, narrative) => {
  let ret = narrative.filter(one => one['id'] === id)
  return (ret.length) ? ret[0]['body'] : narrative[0]['body']
}

const defaultPage = {
  id: 'default',
  'title-en': '',
  'title-ru': '',
  'pages': [{
    'id': 'default',
    'title': 'Bodygraph',
    // 'className': 'calculator',
    'bodygraph': true,
    'component': narrativesComponents.full
  },

    // {
    //   'id': 'channels',
    //   'title': 'Channels',
    //   // 'className': 'calculator',
    //   // 'bodygraph': true,
    //   'component': narrativesComponents.channelsAdv
    // }


  ]
}

export const defaultNarrative = defaultPage